import React, { useCallback, useEffect, useMemo } from "react";
import { useSignal } from "@preact/signals-react";
import { ItineraryDaily } from "./ItineraryDaily";
import { SwitchTab } from "../components/SwitchTab/SwitchTab";
import styles from "./ItineraryPlanning.module.scss";
export function ItineraryPlanning(props) {
  var _current$value, _current$value2, _current$value3;
  var activeKey = useSignal(0);
  var current = useSignal(props.itinerary_list[0]);
  var tabList = useMemo(function () {
    return props.itinerary_list.map(function (item, index) {
      return {
        name: item.Day,
        key: index
      };
    });
  }, [props.itinerary_list]);
  var setActiveKey = useCallback(function (index) {
    if (index === activeKey.value || index > props.itinerary_list.length - 1) return;
    activeKey.value = index;
    current.value = props.itinerary_list[index];
  }, [props.itinerary_list]);
  useEffect(function () {
    var _props$itinerary_list;
    activeKey.value = 0;
    current.value = (_props$itinerary_list = props.itinerary_list) === null || _props$itinerary_list === void 0 ? void 0 : _props$itinerary_list[0];
  }, [props.itinerary_list]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.itineraryPlanning
  }, /*#__PURE__*/React.createElement(SwitchTab, {
    list: tabList,
    activeKey: activeKey,
    setActiveKey: setActiveKey
  }), /*#__PURE__*/React.createElement(ItineraryDaily, {
    daily_plan_title: (_current$value = current.value) === null || _current$value === void 0 ? void 0 : _current$value.daily_plan_title,
    daily_plan: (_current$value2 = current.value) === null || _current$value2 === void 0 ? void 0 : _current$value2.daily_plan,
    Day: (_current$value3 = current.value) === null || _current$value3 === void 0 ? void 0 : _current$value3.Day
  }));
}